import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'

type Props = {
  open: boolean
  onCancel: () => void
  onRetry: () => void
  retrying: boolean
}

export const ReprintDialog: FC<Props> = ({ open, onCancel, onRetry, retrying }) => {
  const { t } = useTranslation()

  return (
    <Dialog open={open} onClose={onCancel}>
      <DialogTitle>{t('print.failed')}</DialogTitle>
      <DialogContent>{t('print.reprintPrompt')}</DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{t('general.button.cancel')}</Button>
        <Button variant="contained" onClick={onRetry} disabled={retrying}>
          {retrying ? t('print.printing') : t('print.failed')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
